import AbstractAmazonPay from './AbstractAmazonPay';

class AmazonPayCheckout extends AbstractAmazonPay {
  /**
   * @inheritdoc
   */
  constructor(opts, $, SGEvent, SGAction, sgData, sgWebStorage = null) {
    super(opts, $, SGEvent, SGAction, sgData, sgWebStorage);
    this.shippingAddressButton = this.$('.js-shipping-edit');
    this.paymentMethodButton = this.$('.js-payment-amazon-edit');
    this.namespace = 'AmazonPayCheckout';
    /**
     * Normally page should not process payUpdate event.
     * When update was initiated from e.x. payment_method page,
     * then everything is unpredictable since we have reloadCheckout too
     * early and it can make some nasty changes in the server state of this checkout.
     * If, however, the interaction is made here, this check should be overriden to process
     * changes correctly.
     * @type {boolean}
     */
    this.ignoreVisibilityOnPayUpdateCallback = false;

    this.handleAmazonDidCreatePaymentRequest = this.handleAmazonDidCreatePaymentRequest.bind(this);
    this.amazonPayDidProcessPayment = this.amazonPayDidProcessPayment.bind(this);
    this.handleAmazonPayDidUpdate = this.handleAmazonPayDidUpdate.bind(this);
    this.handleAbortedProcessPayment = this.handleAbortedProcessPayment.bind(this);
  }

  /**
   * Binds listeners for "change" click events
   * (shipping, invoice, payment instrument).
   *
   * @todo check US since invoice is only available in EU
   */
  bindUpdateHandler() {
    this.shippingAddressButton
      .off(this.namespace)
      .on(`click.${this.namespace}`, () => {
        this.ignoreVisibilityOnPayUpdateCallback = true;
        this.SGAction.amazonPayUpdate({
          orderDetails: 'shippingAddress',
          amazonOrderReferenceId: this.amazonOrderReferenceId,
        });
        return false;
      });

    this.paymentMethodButton
      .off(this.namespace)
      .on(`click.${this.namespace}`, () => {
        this.ignoreVisibilityOnPayUpdateCallback = true;
        this.SGAction.amazonPayUpdate({
          orderDetails: 'paymentMethod',
          amazonOrderReferenceId: this.amazonOrderReferenceId,
        });
        return false;
      });
  }

  /**
   * With this event we need to send the request string for signing.
   * When signature process is OK, then next step is to process payment using
   * native SDK.
   *
   * If not, error should be shown the the user.
   * @param {Object} response response
   */
  handleAmazonDidCreatePaymentRequest(response) {
    $.shopgate.ajax({
      url: 'sgapi:ajax_sign_amazon_process_payment',
      type: 'POST',
      data: {
        stringToSign: window.encodeURIComponent(response.stringToSign),
      },
      success: (msg) => {
        if (!msg.success) {
          // Error handled by $.shopgate.ajax
          return;
        }

        this.SGAction.amazonPayProcessPayment({
          amazonOrderReferenceId: this.amazonOrderReferenceId,
          currencyCode: this.currency,
          totalPrice: this.sgData.cart.amount.complete_amount_string * 1,
          signature: window.decodeURI(msg.data.signature),
          sellerOrderAttributes: {
            sellerStoreName: this.sgData.shop.name,
          },
        });
      },
      error: () => {
        // Most likely our server went down.
        this.showGeneralError();
      },
    });
  }

  handleAmazonPayDidUpdate() {
    if (
      !this.ignoreVisibilityOnPayUpdateCallback
      && !(window.pageInformation && window.pageInformation.visible)
    ) {
      return;
    }
    this.ignoreVisibilityOnPayUpdateCallback = false;
    this.SGEvent.Broadcast.reloadCheckout();
  }

  /**
   * Final step, adds information that it's native sdk call
   * and proceed as usual with the rest of the checkout process.
   * @param {Object} response response
   */
  amazonPayDidProcessPayment(response) {
    if (response.errorCode) {
      this.showGeneralError();
      return;
    }

    this.$checkoutForm
      .append('<input type="hidden" name="isAmazonNativeSDK" value="1" />')
      .data('submitOverridden', false)
      .trigger('submit');
  }

  handleAbortedProcessPayment() {
    // If this happen it means payment_controller moved user back to checkout. Need to prepare.
    this.$checkoutForm.data('submitOverridden', true);
  }

  /**
   * @inheritDoc
   */
  registerEvents() {
    super.registerEvents();
    this.SGEvent.Broadcast.declare('amazonPayProcessPaymentAborted');
    this.SGEvent.Broadcast.register(
      'amazonPayDidCreatePaymentRequest',
      'amazonPayDidProcessPayment',
      'amazonPayDidUpdate',
      'amazonPayProcessPaymentAborted'
    );

    this.SGEvent
      .unregisterCallback(
        `amazonPayDidStart.${this.namespace}, amazonPayDidUpdate.${this.namespace}, amazonPayDidCreatePaymentRequest.${this.namespace}, amazonPayDidProcessPayment.${this.namespace}`, `amazonPayProcessPaymentAborted.${this.namespace}`
      )
      .registerCallback(`amazonPayDidStart.${this.namespace}, amazonPayDidUpdate.${this.namespace}`, this.handleAmazonPayDidUpdate)
      .registerCallback(`amazonPayDidCreatePaymentRequest.${this.namespace}`, this.handleAmazonDidCreatePaymentRequest)
      .registerCallback(`amazonPayDidProcessPayment.${this.namespace}`, this.amazonPayDidProcessPayment)
      .registerCallback(`amazonPayProcessPaymentAborted.${this.namespace}`, this.handleAbortedProcessPayment);
  }

  /**
   * dsfdsfdsf
   * @param {jQuery} $checkoutForm - checkout form
   * @params {string} amazonOrderReferenceId - amazonOrderReferenceId
   */
  initAmazonCheckout({ $checkoutForm = $(), amazonOrderReferenceId }) {
    if (this.isAmazonPaySupported() === false) {
      return;
    }
    if ($checkoutForm.length === 0) {
      throw new Error('$checkoutForm must be an valid jQuery element');
    }
    this.amazonOrderReferenceId = amazonOrderReferenceId;
    this.$checkoutForm = $checkoutForm;
    this.$checkoutForm
      .data('submitOverridden', true)
      .off(`submit.${this.namespace}`)
      .on(`submit.${this.namespace}`, (e) => {
        if (
          this.$checkoutForm.data('submitDisabled')
          || !this.$checkoutForm.data('submitOverridden')
        ) {
          return;
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        this.SGAction.amazonPayCreatePaymentRequest({
          amazonOrderReferenceId: this.amazonOrderReferenceId,
          currencyCode: this.currency,
          totalPrice: this.sgData.cart.amount.complete_amount_string * 1,
          sellerOrderAttributes: {
            sellerStoreName: this.sgData.shop.name,
          },
        });
      });
    this.registerEvents();
    this.bindUpdateHandler();
  }
}

export default AmazonPayCheckout;



// WEBPACK FOOTER //
// ./Library/1.0/app/amazon-pay/AmazonPayCheckout.js